module.exports = __webpack_public_path__ + "static/media/average.53b345a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/average.svg
// module id = 802
// module chunks = 0